<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 14 14"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    d="M9.625 2.625C11.0747 2.625 12.25 3.80025 12.25 5.25V5.875C12.25 6.01307 12.3619 6.125 12.5 6.125C13.3284 6.125 14 6.79657 14 7.625V9C14 9.82843 13.3284 10.5 12.5 10.5C12.3619 10.5 12.25 10.6119 12.25 10.75V11.375C12.25 12.8247 11.0747 14 9.625 14H4.375C2.92525 14 1.75 12.8247 1.75 11.375V10.75C1.75 10.6119 1.63807 10.5 1.5 10.5C0.671573 10.5 9.26124e-08 9.82843 0 9V7.625C0 6.79657 0.671573 6.125 1.5 6.125C1.63807 6.125 1.75 6.01307 1.75 5.875V5.25C1.75 3.80025 2.92525 2.625 4.375 2.625H9.625ZM4.59375 7C3.98969 7 3.5 7.48969 3.5 8.09375C3.5 8.69781 3.98969 9.1875 4.59375 9.1875C5.19781 9.1875 5.6875 8.69781 5.6875 8.09375C5.6875 7.48969 5.19781 7 4.59375 7ZM9.40625 7C8.80219 7 8.3125 7.48969 8.3125 8.09375C8.3125 8.69781 8.80219 9.1875 9.40625 9.1875C10.0103 9.1875 10.5 8.69781 10.5 8.09375C10.5 7.48969 10.0103 7 9.40625 7ZM7 0C7.81682 0.000213871 8.5035 0.560493 8.69629 1.31738C8.75554 1.55132 8.55396 1.75 8.3125 1.75H5.6875C5.4461 1.74994 5.24454 1.55128 5.30371 1.31738C5.49643 0.560382 6.18302 4.6617e-05 7 0Z"
    fill="currentColor"
  />
</svg>
